/**
 * @imports
 */
import React from 'react'
import { Button, Tooltip } from 'antd'

/**
 *
 * @param {*} props
 * @returns
 */
export function ComDetallesEquipoSuministrado(props) {
  return (
    <Tooltip title='Editar detalles del equipo'>
      <Button
        loading={props.loading}
        icon='edit'
        type="default"
        size='small'
        onClick={props.onClick}
      />
    </Tooltip>
  )
}
